import { Controller } from "stimulus"

export default class extends Controller {

  static targets = [ "navbar", "shared_with"]

  static values = {
    page: String,
    filter: String
  }

  connect() {
    if(this.hasNavbarTarget) {
      let navLink;
      if(this.filterValue == "shared") {
        navLink = this.navbarTarget.querySelector(`a[data-page="shared"]`);
      } else if(this.filterValue == "projects") {
        navLink = this.navbarTarget.querySelector(`a[data-page="projects"]`);
      } else {
        navLink = this.navbarTarget.querySelector(`a[data-page="personal"]`);
      }

      if(navLink) {
        navLink.classList.add("text-white")
      }
    }

    this.enableTasksSorting()
    //this.enableSectionsSorting()
  }

  toggleShareWith() {
    switch(event.target.value) {
      case "shared":
        this.shared_withTarget.classList.remove('d-none')
        break;
      default:
        this.shared_withTarget.classList.add('d-none')
    }
  }

  enableTasksSorting() {
    var tasksList = [].slice.call(document.querySelectorAll('.activity_tasks'));

    for (var i = 0; i < tasksList.length; i++) {
    	new Sortable(tasksList[i], {
    		group: 'nested',
    		animation: 150,
    		fallbackOnBody: true,
        swapThreshold: 0.65,
        onEnd: function (evt) {
          let activity = document.querySelector("ul#activity_tasks").dataset.activity
          var tasks = [];
          $('ul.activity_tasks').first().children('li').each(function(){
            if($(this).data('type') == "section") {
              var section = {"id": this.dataset.id, "tasks":[]};
            	$('ul#section_'+$(this).data('id')+'_tasks').first().children('li').each(function(){
                section["tasks"].push(this.dataset.id);
            	});
            	tasks.push(section);
            } else {
              var task = {"id": this.dataset.id};
              //task["id"] = $(this).data("id");
            	tasks.push(task);
            }
          });
          Rails.ajax({
            url: `/${I18n.locale}/activities/tasks/order`,
            type: "post",
            //data: {"activity": activity, "tasks": tasks},
            beforeSend(xhr, options) {
              xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8')
              options.data = JSON.stringify({"activity": activity, "tasks": tasks})
              return true
            },
            success: function(data) {
              if(data) {
                if(data.image != '') {
                  bookmarksController.imageTarget.src = data.image;
                } else {
                  bookmarksController.imageTarget.classList.add('d-none');
                  bookmarksController.imageTarget.parentNode.innerHTML = "<center><i class='far fa-image fa-4x text-muted mt-3'></i></center>"
                }
                bookmarksController.titleTarget.innerHTML = data.title;
                bookmarksController.descriptionTarget.innerHTML = data.description;
                bookmarksController.previewTarget.classList.remove('d-none');
              }
            },
            error: function(data) {}
          });
      	},
    	});
    }

    /*
    new Sortable(activity_tasks, {
        handle: '.handle',
        animation: 150
    });
    */
  }

  enableSectionsSorting() {
    new Sortable(images, {
        handle: '.handle',
        animation: 150
    });
  }
}
